import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../actions'
import GroupstatisticsFilter from './groupstatisticsFilter'

import {List, ListItem} from 'material-ui/List';
import ActionFace from 'material-ui/svg-icons/action/face';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton'
import {lightBlack, darkBlack} from 'material-ui/styles/colors';
import Dialog from 'material-ui/Dialog';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import AppBar from 'material-ui/AppBar';
import Waypoint from 'react-waypoint';
import {Card, CardActions, CardHeader, CardText, CardTitle} from 'material-ui/Card';

var params = '?';
var BarChart = require("react-chartjs").Bar;

class Groupstatistics extends Component {

  componentWillUnmount() {
    if (this.props.errorMessage) {
      this.props.authError(null)
    }
  }

  componentWillMount() {
    this.props.getEnums('/dev.enum/group-types', '?detailed', 'GroupTypes');
    // type filter: enum(pszichodráma asszisztensi,pszichodráma felsőfok,biblodráma asszisztensi,bibliodráma gyakorlat,bibliodráma felsőfok,gyermekdráma asszisztensi,gyermekdráma felsőfok)
    this.props.getEnums('/stats/group-amounts', '?by=year', 'GroupsByYear'); // Filter : type
    this.props.getEnums('/stats/group-amounts', '?by=lessonCount', 'GroupsByLessonCount');  // Filters : type, startsIn, runsIn
    this.props.getEnums('/stats/participant-amounts', '', 'ParticipantAmounts'); // Filter : type
    this.props.getEnums('/stats/top-leaders', '?offset=0&limit=50', 'TopLeaders'); // noFilter
  }

  data1 = () => {
    let labels = []
    let data = []
    let first = this.props.groupsbyyear[0].year
    let last = this.props.groupsbyyear[this.props.groupsbyyear.length - 1].year
    if (first < last) {
      for (var i = first; i <= last; i++) {
        let maybeAnObject = this.props.groupsbyyear.filter(function(obj){
          return obj.year === i;
        })
        if (maybeAnObject.length < 1) {
          labels.push(i+'. év')
          data.push(0)
        } else if (maybeAnObject.length === 1) {
          labels.push(maybeAnObject[0].year+'. év')
          data.push(maybeAnObject[0].count)
        } else {
          maybeAnObject.map((option, index) => {
            labels.push(option.year+'. év')
            data.push(option.count)
          })
        }
      }
    } else {
      for (var i = last; i <= first; i++) {
        let maybeAnObject = this.props.groupsbyyear.filter(function(obj){
          return obj.year === i;
        })
        if (maybeAnObject.length < 1) {
          labels.push(i+'. év')
          data.push(0)
        } else if (maybeAnObject.length === 1) {
          labels.push(maybeAnObject[0].year+'. év')
          data.push(maybeAnObject[0].count)
        } else {
          maybeAnObject.map((option, index) => {
            labels.push(option.year+'. év')
            data.push(option.count)
          })
        }
      }
    }
    return {
      labels: labels,
      datasets: [
        {
          label: "Csoportok évek szerint",
          fillColor: "#FFB74D",
          strokeColor: "#FFB74D",
          pointColor: "rgba(220,220,220,1)",
          pointStrokeColor: "#fff",
          pointHighlightFill: "#fff",
          pointHighlightStroke: "rgba(220,220,220,1)",
          data: data
        }
      ]
    };
  }

  chartOptions1 = () => {
    return {
      gridLines: {
        offsetGridLines: true,
      },
      layout: {
        padding: {
          left: 50,
          right: 50,
          top: 0,
          bottom: 0
        }
      },
      responsive: true,
      hover: {
        // Overrides the global setting
        // mode: 'index'
      }
    }
  }

  data2 = () => {
    let labels = []
    let data = []
    this.props.groupsbylessoncount.map((option, index) => {
      console.log(option)
      labels.push(option.lessonCount+' óra')
      data.push(option.count)
    })
    return {
      labels: labels,
      datasets: [
        {
          label: "Csoportok óraszám szerint",
          fillColor: "#FFB74D",
          strokeColor: "#FFB74D",
          pointColor: "rgba(220,220,220,1)",
          pointStrokeColor: "#fff",
          pointHighlightFill: "#fff",
          pointHighlightStroke: "rgba(220,220,220,1)",
          data: data
        }
      ]
    };
  }

  chartOptions2 = () => {
    return {
      gridLines: {
        offsetGridLines: true,
      },
      layout: {
        padding: {
          left: 50,
          right: 50,
          top: 0,
          bottom: 0
        }
      },
      responsive: true,
      hover: {
        // Overrides the global setting
        // mode: 'index'
      }
    }
  }

  data3 = () => {
    let labels = []
    let data = []
    let first = this.props.participantamounts[0].year
    let last = this.props.participantamounts[this.props.participantamounts.length - 1].year
    if (first < last) {
      for (var k = first; k <= last; k++) {
        let maybeAnObject = this.props.participantamounts.filter(function(obj){
          return obj.year === k;
        })
        if (maybeAnObject.length < 1) {
          labels.push(k+'. év')
          data.push(0)
        } else if (maybeAnObject.length === 1) {
          labels.push(maybeAnObject[0].year+'. év')
          data.push(maybeAnObject[0].count)
        } else {
          maybeAnObject.map((option, index) => {
            labels.push(option.year+'. év')
            data.push(option.count)
          })
        }
      }
    } else {
      for (var k = last; k <= first; k++) {
        let maybeAnObject = this.props.participantamounts.filter(function(obj){
          return obj.year === k;
        })
        if (maybeAnObject.length < 1) {
          labels.push(k+'. év')
          data.push(0)
        } else if (maybeAnObject.length === 1) {
          labels.push(maybeAnObject[0].year+'. év')
          data.push(maybeAnObject[0].count)
        } else {
          maybeAnObject.map((option, index) => {
            labels.push(option.year+'. év')
            data.push(option.count)
          })
        }
      }
    }
    return {
      labels: labels,
      datasets: [
        {
          label: "Csoportok résztvevők száma szerint",
          fillColor: "#FFB74D",
          strokeColor: "#FFB74D",
          pointColor: "rgba(220,220,220,1)",
          pointStrokeColor: "#fff",
          pointHighlightFill: "#fff",
          pointHighlightStroke: "rgba(220,220,220,1)",
          data: data
        }
      ]
    };
  }

  chartOptions3 = () => {
    return {
      gridLines: {
        offsetGridLines: true,
      },
      layout: {
        padding: {
          left: 50,
          right: 50,
          top: 0,
          bottom: 0
        }
      },
      responsive: true,
      hover: {
        // Overrides the global setting
        // mode: 'index'
      }
    }
  }

  scrollTo = (element, to, duration) => {
      //t = current time
      //b = start value
      //c = change in value
      //d = duration
      Math.easeInOutQuad = function (t, b, c, d) {
        t /= d/2;
        if (t < 1) return c/2*t*t + b;
        t--;
        return -c/2 * (t*(t-2) - 1) + b;
      };

      var start = element.scrollTop,
          change = to - start,
          currentTime = 0,
          increment = 20;
          
      var animateScroll = function(){        
          currentTime += increment;
          var val = Math.easeInOutQuad(currentTime, start, change, duration);
          element.scrollTop = val;
          if(currentTime < duration) {
              setTimeout(animateScroll, increment);
          }
      };
      animateScroll();
  }

  handleFilter({type, year}) {
    params = '?';
    if (typeof type !== 'undefined' && type !== 'all') {
      params = params + '&type='+type
    }
    if (typeof year !== 'undefined' && year !== 'all') {
      params = params + '&startsIn='+year
      params = params + '&runsIn='+year
    }
    window.scrollTo(document.body, 0, 1250);
    if (type === 'all' && year === 'all') {
      this.props.getEnums('/stats/group-amounts', '?by=year', 'GroupsByYear'); // Filter : type
      this.props.getEnums('/stats/group-amounts', '?by=lessonCount', 'GroupsByLessonCount');  // Filters : type, startsIn, runsIn
      this.props.getEnums('/stats/participant-amounts', '', 'ParticipantAmounts'); // Filter : type
    } else {
      this.props.getEnums('/stats/group-amounts', params+'&by=year', 'GroupsByYear'); // Filter : type
      this.props.getEnums('/stats/group-amounts', params+'&by=lessonCount', 'GroupsByLessonCount');  // Filters : type, startsIn, runsIn
      this.props.getEnums('/stats/participant-amounts', '', 'ParticipantAmounts'); // Filter : type
    }
  }

  render() {
    if(typeof this.props.groupsbyyear !== 'undefined' && typeof this.props.groupsbylessoncount !== 'undefined' && typeof this.props.participantamounts !== 'undefined' && typeof this.props.topleaders !== 'undefined') {
      return (
        <div style={{paddingBottom: 50}}>
          <AppBar
            title="Csoport statisztikák"
          />
          <GroupstatisticsFilter
            onSubmit={this.handleFilter.bind(this)}
            grouptypes={this.props.grouptypes}
            groupsbyyear={this.props.groupsbyyear}
            errorMessage={this.props.errorMessage} />
          <div className="cardWrapper">
            <Card className="soloCard" key={0}>
              <CardTitle title="Csoportok évek szerint" subtitle="" />
              <CardText expandable={false}>
                <span className='toleftbar'>darab</span>
                <BarChart data={this.data1()} options={this.chartOptions1()} redraw />
                <span className='tobottombar'>év</span>
              </CardText>
            </Card>
            <Card className="soloCard" key={1}>
              <CardTitle title="Csoportok óraszám szerint" subtitle="" />
              <CardText expandable={false}>
                <span className='toleftbar'>csoportok száma</span>
                <BarChart data={this.data2()} options={this.chartOptions2()} redraw />
                <span className='tobottombar'>óraszám</span>
              </CardText>
            </Card>
            <Card className="soloCard" key={3}>
              <CardTitle title="Résztvevők száma" subtitle="" />
              <CardText expandable={false}>
                <span className='toleftbar'>résztvevők</span>
                <BarChart data={this.data3()} options={this.chartOptions3()} redraw />
                <span className='tobottombar'>év</span>
              </CardText>
            </Card>
            <Card className="soloCard list" key={4}>
              <CardTitle title="Csoportvezetők - csoportszámok listája" subtitle="" />
              <CardText expandable={false}>
                <List>
                {
                  this.props.topleaders.map((option, index) => {
                    return <ListItem
                      //onClick={this.handleOpen.bind(this, option.id)}
                      key={index}
                      leftIcon={<ActionFace />}
                      primaryText={
                        <span>
                          <a href={"/persons/"+option.id} target="_blank">
                            <span style={{color: darkBlack}}>{option.name} - {option.count} vezetett csoport</span>
                          </a>
                        </span>
                      }
                      />
                  })

                }
                </List>
                <Waypoint onEnter={({ previousPosition, currentPosition, event }) => {
                    if (this.props.topleaders.length > 49) {
                      this.props.getEnums('/stats/top-leaders', '?offset='+this.props.topleaders.length+'&limit=50', 'TopLeadersMore');
                    }
                  }}
                />
              </CardText>
            </Card>
          </div>
        </div>
      )
    } else {
      return (
        <div>
          <p style={{margin: 16, textAlign: "center"}}><strong>Töltünk...</strong></p>
        </div>

      )

    }
  }
}

function mapStateToProps(state) {
  return {
    groupsbyyear: state.statistics.groupsbyyear,
    groupsbylessoncount: state.statistics.groupsbylessoncount,
    participantamounts: state.statistics.participantamounts,
    topleaders: state.statistics.topleaders,
    grouptypes: state.groups.grouptypes,
    errorMessage: state.auth.error
  }
}

export default connect(mapStateToProps, actions)(Groupstatistics)


// WEBPACK FOOTER //
// ./src/components/groupstatistics/groupstatistics.js